<template>
  <div class="mt-8 mb-8">
    <h1 class="page-title">
      <template v-for="(label, index) in labels" :key="index">
        {{ label }}
        <span class="space-icon"></span>
        <i v-if="showIcon(index)" class="fa-solid fa-chevron-right fa-xs"></i>
        <span class="space-icon"></span>
      </template>
    </h1>
  </div>
</template>

<script>
export default {
  name: "BreadCrumbs",
  props: {
    labels: {
      type: Array,
      required: true
    }
  },
  methods: {
    showIcon(index) {
      return (this.labels.length > 1) & (index < this.labels.length - 1);
    }
  }
};
</script>
